import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Table} from 'antd'

class AvailableCoupons extends Component {
  state={success:null, result:[]};

  componentDidMount () {
    const couponId= this.props.coupon;
    this.fetchAvailableCoupons(couponId);
  }

    fetchAvailableCoupons = couponId => {
      fetch(
        `https://appvendedores.comprasdavivienda.cr/resources/ws/getAvailableCodesByCoupon.php/getAvailableCodesByCoupon?coupon=${couponId}`)
        .then(response => response.json())
        .then ((data) => {this.setState({dataApi:data, success:data.success, result: data.result})
      })
        .catch(error => alert(error.message));
    }
  
render() {

const columns = [
{
  title: 'Código cupón',
  dataIndex: 'code',
  key: 'code',
  render: text => <span>{text}</span>,
},

{
  title: 'Fecha vencimiento',
  dataIndex: 'expiration_date',
  key: 'expiration_date',
},

]

if (this.state.success == 0) {
    return  <p>No hay cupones disponibles.</p>;
} else{
  return (
    <Table
      className="gx-table-responsive"
      columns={columns}
      dataSource={this.state.result}
    />
  )
}  
  }
}

  
export default connect ()(AvailableCoupons);


// WEBPACK FOOTER //
// ./src/routes/main/Cupons/admin/AvailableCoupons.js